import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " class=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"class") : stack1), depth0))
    + "\"";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<section>\n  <h2 "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"class") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":6},"end":{"line":2,"column":56}}})) != null ? stack1 : "")
    + ">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</h2>\n</section>\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/headline-mortgage-overview-module",
  "version": "3.0.0",
  "id": "headlineMortgageOverviewModule",
  "containerID": "homeLoansHeadlineMortgageOverviewModule",
  "moduleName": "home-loans-headline-mortgage-overview-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "headline-mortgage-overview-module",
  "data": {
    "init": "headlineMortgageOverviewModuleJS",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/**
 * @class headlineMortgageOverviewModuleJS
 * @extends {Module}
 */
class headlineMortgageOverviewModuleJS extends Module {
  /**
   * Creates an instance of headlineMortgageOverviewModuleJS.
   * @param {Object} options Module options
   * @param {Object} context Module context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * @returns {void}
   */
  init() {
    const disclosuresDaggerIntroRate = document.querySelectorAll('#disclosuresDaggerIntroRateMortgage, #disclosuresDaggerIntroRateRefinance');
    if (disclosuresDaggerIntroRate.length > 0) {
      // nodelist foreach is not working in IE so using array prototype here
      Array.prototype.forEach.call(disclosuresDaggerIntroRate, link => {
        if (window.sparta.language === 'es') {
          link.setAttribute('aria-label', 'nota');
        } else {
          link.setAttribute('aria-label', 'footnote');
        }
      });
    }
  }
}
registerModuleClass({
  moduleClass: headlineMortgageOverviewModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { headlineMortgageOverviewModuleJS as default, moduleConfig };
